import { useQuery } from "@tanstack/react-query";
import { api, endpoints } from "../lib/api";
import Topbar from "../components/Topbar";
import { euro } from "../lib/format";
import { Sparkles } from "lucide-react";

const CATS = {
  depilacion_laser: { label: "Depilación láser", color: "#D6B36A" },
  faciales_glow: { label: "Faciales glow y limpieza avanzada", color: "#c9a76d" },
  fototerapia_led: { label: "Fototerapia LED", color: "#a3a394" },
  rejuvenecimiento: { label: "Rejuvenecimiento y firmeza", color: "#1A1A1A" },
  corporal_bienestar: { label: "Corporal y bienestar", color: "#7d6b58" },
  beauty_complementario: { label: "Beauty complementario", color: "#B8B8B8" },
};

export default function Services() {
  const { data: services = [] } = useQuery({ queryKey: ["services"], queryFn: () => api.get(endpoints.services).then((r) => r.data) });

  const grouped = services.reduce((acc, s) => {
    (acc[s.category] ||= []).push(s);
    return acc;
  }, {});

  return (
    <div>
      <Topbar
        title="Servicios y tratamientos"
        subtitle="Catálogo LAKA por categoría. Duración, precio y margen estimado."
      />

      <div className="space-y-8">
        {Object.entries(CATS).map(([cat, meta]) => (
          <div key={cat} data-testid={`services-category-${cat}`}>
            <div className="flex items-center gap-2 mb-4">
              <span className="w-1.5 h-1.5 rounded-full" style={{ backgroundColor: meta.color }} />
              <h3 className="font-display text-2xl">{meta.label}</h3>
              <span className="text-xs" style={{ color: "var(--laka-text)" }}>· {(grouped[cat] || []).length} tratamientos</span>
            </div>
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
              {(grouped[cat] || []).map((s) => (
                <div key={s.id} className="laka-card p-6 hover:border-[#D6B36A] transition-colors">
                  <div className="flex items-start justify-between">
                    <h4 className="font-medium text-sm">{s.name}</h4>
                    <Sparkles size={14} strokeWidth={1.25} style={{ color: "#D6B36A" }} />
                  </div>
                  <p className="text-xs mt-2 min-h-[36px]" style={{ color: "var(--laka-text)" }}>{s.description}</p>
                  <div className="mt-4 pt-4 border-t laka-hairline flex items-end justify-between">
                    <div>
                      <div className="text-[10px] uppercase tracking-widest" style={{ color: "var(--laka-text)" }}>Duración</div>
                      <div className="text-sm font-medium">{s.duration_min} min</div>
                    </div>
                    <div className="text-right">
                      <div className="text-[10px] uppercase tracking-widest" style={{ color: "var(--laka-text)" }}>Precio</div>
                      <div className="font-display text-2xl leading-none" style={{ color: "#D6B36A" }}>{euro(s.price)}</div>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
